import { shallowRef } from 'vue';

const activeDialog = shallowRef(null);
let resolveDialog;

export class DialogService {
  static get active() {
    return activeDialog;
  }

  static confirm(options) {
    // Only one confirmation can own the modal at a time.
    this.close(false);
    activeDialog.value = options;
    return new Promise((resolve) => {
      resolveDialog = resolve;
    });
  }

  static close(confirmed) {
    activeDialog.value = null;
    resolveDialog?.(confirmed);
    resolveDialog = undefined;
  }
}
